import React, { useState, useCallback } from 'react';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
// import { EntryPageTemplate } from 'gw-components-platform-react';
import  EntryPageTemplate from '../../customer/modules-react/nexus-components-platform-react/EntryPageTemplate/EntryPageTemplate';
import queryString from 'query-string';


import metadata from './EntryPage.metadata.json5';
import styles from './EntryPage.module.scss';

const { applicationDetails } = appConfig;

const VIEWS = {
    logInView: 'LOG_IN_VIEW',
    signUpView: 'SIGN_UP_VIEW',
    forgotPasswordView: 'FORGOT_PASSWORD_VIEW'
};

function EntryPage({ location }) {
    const { state, search } = location;
    const queryParams = queryString.parse(search);
    const [view, updateView] = useState(VIEWS.logInView);
    let bmsSuccessPath;
    if(queryParams){
        const accessToken = (queryParams["access_token"] == undefined) ? queryParams["amp;access_token"] : queryParams["access_token"];
        const policyNumber = (queryParams["policy_number"] == undefined) ? queryParams["amp;policy_number"] : queryParams["policy_number"];
        const viewType = (queryParams["view_type"] == undefined) ? queryParams["amp;view_type"] : queryParams["view_type"];
        const jobNumber = (queryParams["job_number"] == undefined) ? queryParams["amp;job_number"] : queryParams["job_number"];
        if(viewType === "summary"){        
             bmsSuccessPath = "/policies/"+policyNumber+"/summary";

        }else if(viewType === "claims"){
             bmsSuccessPath = "/policies/"+policyNumber+"/claims";
        }else if(viewType === "billing"){
             bmsSuccessPath = "/policies/"+policyNumber+"/billing";
        } else if (viewType === "quotesummary") {
            bmsSuccessPath = "/quotes/"+jobNumber+"/summary";
        } else {
            // redirect user to home view
            bmsSuccessPath = '/home';
        } 
    }

    const handleForgotPasswordClick = useCallback(() => {
        updateView(VIEWS.forgotPasswordView);
    }, []);

    const handleSignInClick = useCallback(() => {
        updateView(VIEWS.logInView);
    }, []);

    const overrideProps = {
        gwLoginComponent: {
            successPath: bmsSuccessPath ? bmsSuccessPath : (_.get(state, 'from.pathname') || '/home'),
            searchParam: search
        },
        logInViewContainer: {
            visible: view === VIEWS.logInView
        },
        forgotPasswordViewContainer: {
            visible: view === VIEWS.forgotPasswordView
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onForgotPasswordClick: handleForgotPasswordClick,
            onSignInClick: handleSignInClick
            /*onSignUpClick: handleSignUpClick,
            onSignInClick: handleSignInClick*/
        }
    };

    const renderedContentFromMetadata = renderContentFromMetadata(
        metadata.pageContent,
        overrideProps,
        resolvers
    );

    return (
        <EntryPageTemplate
            applicationName={applicationDetails.applicationName}
            applicationLogo={applicationDetails.applicationLogo}
            contentToRender={renderedContentFromMetadata}
            applicationMobileLogo={applicationDetails.applicationMobileLogo}
            applicationLogo2={applicationDetails.applicationLogo2}
        />
    );
}

EntryPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    location: PropTypes.shape({
        state: PropTypes.shape({})
    })
};

EntryPage.defaultProps = {
    location: {}
};

export default EntryPage;
